import React from "react";
import { ControlLabel } from "react-bootstrap";
import { yandexMetricaGoals } from "../../models";

const YandexMetrika = () => {
    return (
        <>
            <ControlLabel>Описание целей для Яндекс Метрики</ControlLabel>
            <table className="metrica-table">
                <thead>
                <tr>
                    <th>Действие пользователя</th>
                    <th>Цель Метрики </th>
                </tr>
                </thead>
                <tbody>
                {yandexMetricaGoals.map((row) => (
                    <tr key={row.label}>
                        <td>{row.action}</td>
                        <td>{row.goal}</td>
                    </tr>
                ))}
                </tbody>
            </table>
            <p>Не забудь в настройках этого мероприятия добавить счётчик Яндекс Метрики (раздел Модули)</p>
        </>
    );
};

export default YandexMetrika;
